import React from 'react'
import { Text, csx } from '@vtex/admin-ui'
import { FormattedMessage } from 'react-intl'

import { Icon } from '../../../../../../ui/components/Icon'
import { EmptyStateIcon } from './EmptyStateIcon'

export const EmptyState = () => {
  return (
    <div
      className={csx({
        flexDirection: 'column',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        flex: 1,
        transform: `translateY(-$space-8)`,
      })}
    >
      <Icon
        className={csx({
          width: '6.458rem',
          height: '5.167rem',
        })}
      >
        <EmptyStateIcon />
      </Icon>
      <Text
        variant="display"
        className={csx({
          marginTop: '2.792rem',
        })}
      >
        <FormattedMessage id="checkout.advertisements.empty-state.title" />
      </Text>
      <Text
        variant="title2"
        tone="secondary"
        className={csx({
          marginTop: '$space-3',
          maxWidth: '20.438rem',
          textAlign: 'center',
        })}
      >
        <FormattedMessage id="checkout.advertisements.empty-state.subtitle" />
      </Text>
    </div>
  )
}
